<div class="relative flex flex-col w-full h-full">
  <div class="p-8 pb-6 sm:pb-8">
    <div class="flex flex-col items-center mt-4 sm:mt-0 text-center">
      <!-- Title -->
      <div class="text-xl leading-6 font-medium">
        {{ 'loadingDialog.title' | translate }}
      </div>

      <!-- Message -->
      <div class="text-secondary">
        {{ 'loadingDialog.message' | translate }}
      </div>

      <!-- Loading animation -->
      <div class="w-48 h-48 mt-4">
        <svg
          id="Ebene_1"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 299.2 166.6">
          <!-- Generator: Adobe Illustrator 29.5.1, SVG Export Plug-In . SVG Version: 2.1.0 Build 141)  -->
          <path
            class="stroke"
            d="M299.2,85c0,26-8.7,48.8-25.5,62.9-11.9,9.9-27.3,15.5-47.5,15.5h-15l21-28.4c25.1-2.8,34.1-20.9,34.1-50s-13.9-54-41.4-54h-26v104.6l-20.5,27.8h-12V3.2h62.5c42.8,0,70.3,34.5,70.3,81.8Z" />
          <path
            class="stroke"
            d="M148,78.1v85.1h-25.6v-21.5c.1,0-.3,0-.3,0-11,18.4-26,24.9-45,24.9s-43-8.7-56.2-23.3C7.6,128.5,0,107.9,0,83.7S9.4,33.8,26.2,18.4C39.2,6.5,56.2,0,77.7,0c38.3,0,61,20.1,67.6,48.9h-32.2c-4.7-13-16.2-22.1-34.7-22.1-30.2,0-45.2,25.1-45.2,56.9s17.2,56.7,44.8,56.7,33.5-18.6,33.5-36.3v-.9h-40.3l18.6-25.1h58.3Z" />
        </svg>
      </div>
    </div>
  </div>
</div>
